export default "__VITE_ASSET__a7931d7d__"